export default class Console {
  static install(Vue) {
    Vue.prototype.$logWarn = function (system, page, message) {
      console.warn(`[${system}][${page}] - ${message}`)
    }
    Vue.prototype.$logError = function (system, page, message) {
      console.error(`[${system}][${page}] - ${message}`)
    }
  }
}
